<script lang="ts">
    import { createHistory, createMemorySource, Route, Router } from 'svelte-navigator';
    import RouteGuard from './RouteGuard.svelte';
    import Dailer from '../screens/Call/Dailer.svelte';
    import Chat from '../screens/Chat/Page.svelte';
    import Home from '../screens/Home/index.svelte';
    import Profile from '../screens/Home/Profile.svelte';
    import OTP from '../screens/Auth/OTP.svelte';
    import Login from '../screens/Auth/index.svelte';
    import Rate from '../screens/Feedback/Rate.svelte';
    import Message from '../screens/Feedback/Message.svelte';
    import PageNotExists from '../screens/PageNotExists.svelte';
    import PrivateRoute from './PrivateRoute.svelte';
    import Business from '../screens/Settings/Business.svelte';
    import Numbers from '../screens/Settings/Numbers.svelte';
    import Logs from '../screens/Call/Logs.svelte';
    import Contact from '../screens/Call/Contact.svelte';
    import AddContact from '../screens/Call/AddContact.svelte';
    import Queue from '../screens/Call/Queue.svelte';

    const memoryHistory = createHistory(createMemorySource());
</script>

<Router history={memoryHistory} primary={false}>
    <div class="main">
        <PrivateRoute exact path="/">
            <Home />
            <!-- <Dailer /> -->
        </PrivateRoute>
        <RouteGuard path="/login">
            <Login />
        </RouteGuard>
        <RouteGuard path="/otp">
            <OTP />
        </RouteGuard>
        <RouteGuard path="/choose-business">
            <Business />
        </RouteGuard>
        <RouteGuard path="/choose-number">
            <Numbers />
        </RouteGuard>
        <PrivateRoute path="/chat">
            <Chat />
        </PrivateRoute>
        <PrivateRoute path="/call">
            <Dailer />
        </PrivateRoute>
        <PrivateRoute path="/call-logs">
            <Logs />
        </PrivateRoute>
        <PrivateRoute path="/queue">
            <Queue />
        </PrivateRoute>
        <PrivateRoute path="/contacts">
            <Contact />
        </PrivateRoute>
        <PrivateRoute path="/add-contact">
            <AddContact />
        </PrivateRoute>
        <PrivateRoute path="/rate">
            <Rate />
        </PrivateRoute>
        <PrivateRoute path="/message">
            <Message />
        </PrivateRoute>
        <PrivateRoute path="/profile">
            <Profile />
        </PrivateRoute>
        <Route>
            <PageNotExists />
        </Route>
    </div>
</Router>

<style>
    .main {
        height: 100%;
        overflow: hidden;
    }
</style>
